import { render, staticRenderFns } from "./bindAccountModal.vue?vue&type=template&id=1d090b4a&scoped=true&"
import script from "./bindAccountModal.vue?vue&type=script&lang=ts&"
export * from "./bindAccountModal.vue?vue&type=script&lang=ts&"
import style0 from "./bindAccountModal.vue?vue&type=style&index=0&id=1d090b4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d090b4a",
  null
  
)

export default component.exports